import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-header-dk",
  "use": "icon-header-dk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-header-dk\"><path d=\"M465.454545 0l93.09091 1024H0L93.090909 0h372.363636z m-51.153454 465.454545H144.244364l-8.448 93.09091h286.952727l-8.448-93.09091z m558.917818 0h-372.363636L558.545455 0h372.363636l42.309818 465.454545z m8.471273 93.09091L1024 1024H651.636364l-42.309819-465.454545h372.363637z\" fill=\"#333333\" p-id=\"5725\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol